import React, { createContext, useState } from 'react';

export const SourceContext = createContext();

export const SourceProvider = ({ children }) => {
  const [sources, setSources] = useState([]);

  const addSource = (newData) => {
    setSources((prev) => [...prev, newData]);
  };

  return (
    <SourceContext.Provider value={{ sources, addSource }}>
      {children}
    </SourceContext.Provider>
  );
};

